import CompanyHitShort from "models/companies/CompanyHitShort";
import NoteHitShort from "models/notes/NoteHitShort";
import PeopleHitShort from "models/people/PeopleHitShort";

const HistoryListItemShort = ({ object: history, primaryClick }) => {
  if (history.content_type_model === "app.company") {
    return (
      <CompanyHitShort
        hit={history.content_object}
        onClick={() => primaryClick(history)}
      />
    );
  } else if (history.content_type_model === "app.people") {
    return (
      <PeopleHitShort
        hit={history.content_object}
        onClick={() => primaryClick(history)}
      />
    );
  } else if (history.content_type_model === "notes.note") {
    return (
      <NoteHitShort
        hit={history.content_object}
        onClick={() => primaryClick(history)}
      />
    );
  } else throw new Error("Invalid content type");
};

export default HistoryListItemShort;
